import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { LocationStrategy, PlatformLocation, Location, isPlatformBrowser } from '@angular/common';

declare var $: any;
var misc: any = {
    navbar_menu_visible: 0,
    active_collapse: true,
    disabled_collapse_init: 0
}
@Component({
    selector: 'fixedplugin-cmp',
    templateUrl: 'fixedplugin.component.html'
})

export class FixedPluginComponent implements OnInit {
    background_image: boolean = true;
    location: Location;
    state: boolean = true;
    constructor(location: Location, @Inject(PLATFORM_ID) private platformId: Object) {
        this.location = location;
    }
    ngOnInit() {
        if (isPlatformBrowser(this.platformId)) {
            var $sidebar = $('.sidebar');
            var $sidebar_img_container = $sidebar.find('.sidebar-background');

            var $full_page = $('.full-page');

            var $sidebar_responsive = $('body > .navbar-collapse');

            var window_width = $(window).width();

            if (window_width > 767) {
                if ($('.fixed-plugin .dropdown').hasClass('show-dropdown')) {
                    $('.fixed-plugin .dropdown').addClass('open');
                }

            }

            $('.fixed-plugin a').click((event: any) => {
                // Alex if we click on switch, stop propagation of the event, so the dropdown will not be hide, otherwise we set the  section active
                if ($(this).hasClass('switch-trigger')) {
                    if (event.stopPropagation) {
                        event.stopPropagation();
                    }
                    else if (window.event) {
                        window.event.cancelBubble = true;
                    }
                }
            });

            $('.fixed-plugin .badge').click(() => {
                var $full_page_background = $('.full-page-background');

                $(this).siblings().removeClass('active');
                $(this).addClass('active');

                var new_color = $(this).data('color');

                if ($sidebar.length != 0) {
                    $sidebar.attr('data-color', new_color);
                }

                if ($full_page.length != 0) {
                    $full_page.attr('data-color', new_color);
                }

                if ($sidebar_responsive.length != 0) {
                    $sidebar_responsive.attr('data-color', new_color);
                }
            });

            $('.fixed-plugin .img-holder').click(() => {
                var $full_page_background = $('.full-page-background');

                $(this).parent('li').siblings().removeClass('active');
                $(this).parent('li').addClass('active');


                var new_image = $(this).find("img").attr('src');

                if ($sidebar_img_container.length != 0) {
                    $sidebar_img_container.fadeOut('fast', () => {
                        $sidebar_img_container.css('background-image', 'url("' + new_image + '")');
                        $sidebar_img_container.fadeIn('fast');
                    });
                }

                if ($full_page_background.length != 0) {

                    $full_page_background.fadeOut('fast', () => {
                        $full_page_background.css('background-image', 'url("' + new_image + '")');
                        $full_page_background.fadeIn('fast');
                    });
                }

                if ($sidebar_responsive.length != 0) {
                    $sidebar_responsive.css('background-image', 'url("' + new_image + '")');
                }
            });
        }
    }
    onChange($event: any) {
        var $sidebar = $('.sidebar');
        var $sidebar_img_container = $sidebar.find('.sidebar-background');

        var $full_page = $('.full-page');
        var $full_page_background = $('.full-page-background');
        var $sidebar_responsive = $('body > .navbar-collapse');
        if ($event.currentValue) {
            if ($sidebar_img_container.length != 0) {
                $sidebar_img_container.fadeIn('fast');
                $sidebar.attr('data-image', '#');
            }

            if ($full_page_background.length != 0) {
                $full_page_background.fadeIn('fast');
                $full_page.attr('data-image', '#');
            }

            this.background_image = true;
        } else {
            if ($sidebar_img_container.length != 0) {
                $sidebar.removeAttr('data-image');
                $sidebar_img_container.fadeOut('fast');
            }

            if ($full_page_background.length != 0) {
                $full_page.removeAttr('data-image', '#');
                $full_page_background.fadeOut('fast');
            }

            this.background_image = false;
        }
    }
    onChange1($event: any) {
        var $body = $('body');
        if (misc.sidebar_mini_active == true) {
            $('body').removeClass('sidebar-mini');
            misc.sidebar_mini_active = false;
        } else {

            $('.sidebar .collapse').collapse('hide').on('hidden.bs.collapse', () => {
                $(this).css('height', 'auto');
            });

            setTimeout(() => {
                $('body').addClass('sidebar-mini');

                $('.sidebar .collapse').css('height', 'auto');
                misc.sidebar_mini_active = true;
            }, 300);
        }

        // we simulate the window Resize so the charts will get updated in realtime.
        var simulateWindowResize = setInterval(() => {
            window.dispatchEvent(new Event('resize'));
        }, 180);

        // we stop the simulation of Window Resize after the animations are completed
        setTimeout(() => {
            clearInterval(simulateWindowResize);
        }, 1000);
    }
    onChange2($event: any) {
        var $nav = $('nav.navbar').first();

        if ($nav.hasClass('navbar-fixed')) {
            $nav.removeClass('navbar-fixed').prependTo('.main-panel');
        } else {
            $nav.prependTo('.wrapper').addClass('navbar-fixed');
        }
    }
    isPages() {
        if (this.location.prepareExternalUrl(this.location.path()) == '/auth/login' || this.location.prepareExternalUrl(this.location.path()) == '/auth/register' ||
            this.location.prepareExternalUrl(this.location.path()) == '/auth/lock') {
            return false;
        }
        else {
            return true;
        }
    }
}
